export default __webpack_public_path__ + "static/media/semitrailer.1d5a72b3.svg";